<template>
  <div class="field-option-seats-picker-wrapper">
    <van-field
      :value="seats.length ? `已选${seats.length}个座位` : ''"
      readonly
      label="座位"
      size="large"
      class="input-field"
      placeholder="请选择座位"
      right-icon="arrow"
      @click="toggleSeatsPicker"
    />
    <van-popup v-model="isSeatsPickerShown" position="bottom" :style="{ height: '100%' }" >
      <div class="detail" style="text-align:center;margin-bottom:20px">
        <p>{{ticket}}</p>
        <p style="margin-bottom:20px"><span>{{date}}</span>&nbsp;&nbsp;<span>{{scene}}</span></p>
        <van-image v-if="layout" width="70%" :src="layout" @click.stop @click="showTheatreLayout" />
      </div>
      <div class="popup-wrapper">
        <div class="content-wrapper">
          <div class="seat-info-wrapper">
            <!-- <van-button
              v-if="layout"
              type="info"
              size="small"
              class="seat-info-button"
              @click="showTheatreLayout"
              >剧场布局</van-button
            > -->
            <div class="seat-info-item">
              <van-checkbox :value="false">
                <template #icon="props">   
                  <img  class="img-icon" :src="props.checked ? selectIcon : optionalIcon" /> 
                </template>
                可选
              </van-checkbox>
            </div>
            <div class="seat-info-item">
              <van-checkbox :value="true">
                <template #icon="props">   
                  <img  class="img-icon" :src="props.checked ? selectIcon : optionalIcon" /> 
                </template>
                已选
              </van-checkbox>
            </div>
            <div class="seat-info-item">
              <van-checkbox :value="true">
                <template #icon="props">   
                  <img  class="img-icon" :src="props.checked ? soldIcon : optionalIcon" /> 
                </template>
                已售
              </van-checkbox>
            </div>
          </div>
          <!-- <van-notice-bar mode="closeable" class="tip"
            >下方选座界面可以滑动并缩放</van-notice-bar
          > -->
          <div class="seats-picker-wrapper" ref="seats-picker-wrapper">
            <display-scale ref="display-scale">
              <van-checkbox-group v-model="seats" class="seats-container">
                <van-divider>舞台</van-divider>
                <div
                  class="seats-row"
                  v-for="item of serializedSeats"
                  :key="item.row"
                >
                  <span v-if="item.row" class="title">第{{ item.row }}排</span>
                  <display-seat
                    v-for="(seat, seatIndex) of item.cols"
                    :key="seatIndex"
                    :value="seat"
                  />
                  <van-divider v-if="!item.row" dashed>过道</van-divider>
                </div>
              </van-checkbox-group>
            </display-scale>
          </div>
        </div>
        <div class="title-wrapper">
          <span class="title">已选座位</span>
          <span v-if="!seats.length">0个</span>
          <div class="selected-seats-wrapper" style="display: contents;">
            <display-tag
              v-for="seat of seats"
              :key="seat"
              :value="seat"
              :text="`${seat.split('-').join('排')}座`"
              @delete="handleDelete"
            />
          </div>
        </div>
      </div>
      <div class="sure">
        <van-button icon="success" color="linear-gradient(to right, #7232dd, #9E73E8)" block @click="isSeatsPickerShown = false"
          >确定选座</van-button
        >
      </div>
    </van-popup>
    <van-overlay
      class="layout-wrapper"
      :show="isTheatreLayoutShown"
      :z-index="20000"
      :custom-style="{ display: 'flex', alignItems: 'center' }"
      @click="isTheatreLayoutShown = false"
    >
      <van-image width="100%" :src="layout" @click.stop />
    </van-overlay>
  </div>
</template>
<script>
import Vue from 'vue';
import { Sticky } from 'vant';
import DisplayTag from './DisplayTag.vue';
import DisplaySeat from './DisplaySeat.vue';
import DisplayScale from './DisplayScale.vue';
import selectIcon from '@/assets/img/selected.png'
import optionalIcon from '@/assets/img/optional.png'
import soldIcon from '@/assets/img/sold.png'

Vue.use(Sticky);

export default {
  components: {
    DisplayTag,
    DisplaySeat,
    DisplayScale,
  },
  props: {
    items: [Array],
    max: [Number],
    layout: [String],
    ticket:[String]
  },
  data() {
    return {
      isSeatsPickerShown: false,
      isTheatreLayoutShown: false,
      seats: [],
      selectIcon,
      optionalIcon,
      soldIcon,
    };
  },
  computed: {
    serializedSeats() {
      return this.serializeSeats(this.items);
    },
    scene(){
      return sessionStorage.getItem('scene')
    },
    date(){
      return this.$route.query.date
    }
  },
  watch: {
    seats(val) {
      if (this.max && this.max < val.length) {
        this.seats = val.slice(val.length - this.max, val.length);
        return;
      }
      this.$emit('change', val);
    },
  },
  methods: {
    toggleSeatsPicker() {
      // if (!this.isSeatsPickerShown && !this.items.length) {
      //   this.$toast.fail('请先选择日期');
      //   return;
      // }
      this.isSeatsPickerShown = !this.isSeatsPickerShown;
      this.$nextTick(this.handleInitialScale);
    },
    serializeSeats(seats) {
      return seats.map(({ row, cols }) => ({
        row,
        cols: cols.map(item => {
          let status = 1;
          if (!item) status = 0;
          if (item === -1) status = 2;
          return {
            row,
            status,
            column: item,
          };
        }),
      }));
    },
    // serializeRows(rows) {
    //   return rows.map((row, index) => {
    //     const prevAndSelfRows = rows.slice(0, index);
    //     const rowNo = prevAndSelfRows.reduce((total, item)
    //  => (total + (item.length ? 1 : 0)), 1);
    //     return {
    //       row: row.length ? rowNo : 0,
    //       children: this.serializeColumns(row, rowNo),
    //     };
    //   }).reverse();
    // },
    // serializeColumns(columns, rowNo) {
    //   return columns.map(column => ({
    //     row: rowNo,
    //     column,
    //     // eslint-disable-next-line
    //     status: column === 'x' ? 2 : column === 0 ? 0 : 1,
    //   }));
    // },
    handleDelete(value) {
      this.seats = this.seats.filter(item => item !== value);
    },
    clearSeats() {
      this.seats = [];
    },
    handleInitialScale() {
      const el = this.$refs['seats-picker-wrapper'];
      const ds = this.$refs['display-scale'];
      if (typeof el.scrollTo === 'function') {
        const scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
        const scrollTop =
          (el.scrollHeight - ds.$el.clientHeight * ds.scale) / 2;
        el.scrollTo(scrollLeft, scrollTop);
      }
    },
    showTheatreLayout() {
      this.isTheatreLayoutShown = true;
    },
  },
};
</script>
<style lang="less" scoped>
.field-option-seats-picker-wrapper {
  .input-field::after {
    border: none;
  }
  .popup-wrapper {
    .title-wrapper {
      position: fixed;
      bottom: 44px;
      width: 100%;
      background-color: #fff;
      padding: 12px 16px;
      display: flex;
      align-items: center;
      overflow-y: auto;
      .title {
        padding-right: 8px;
        width: 64px;
        white-space: nowrap;
      }
      .selected-seats-wrapper {
        flex: 1;
        overflow-x: scroll;
        white-space: nowrap;
        height: 28px;
      }
    }
    .content-wrapper {
      margin-bottom: 80px;
      .seat-info-wrapper {
        text-align: center;
        position: relative;
        .seat-info-button {
          position: absolute;
          top: -4px;
          left: 16px;
        }
        .seat-info-item {
          display: inline-flex;
          align-items: center;
          margin: 0 4px;
          .sold /deep/.van-icon {
            background: red;
            border-color: red;
          }
          [aria-checked='false'] /deep/.van-icon {
            border-color: #999;
          }
        }
      }
      .tip {
        margin-top: 8px;
      }
      .seats-picker-wrapper {
        min-height: 275px;
        max-height: 375px;
        overflow: auto;
        text-align: center;
        white-space: nowrap;
        .seats-container {
          display: inline-block;
          position: relative;
          padding: 16px 60px;
          .title {
            position: absolute;
            left: 16px;
            height: 40px;
            line-height: 40px;
            font-size: 80%;
          }
        }
      }
    }
  }
  .detail{
    p{
      margin: 10px 0;
      color: #666;
    }
    .tip{
      width: 90%;
      margin: 0 auto;
      height: 40px;
      line-height: 40px;
      background-color: #EBEBEB;
    }
  }
}
.img-icon {
  height: 100%;
}
.sure{
  text-align:center;
  position: fixed;
  bottom:0;
  width:100%;
}
</style>
